<template>
    <div class="block-ftr-main">
        <div class="block-ftr-con">
            <PrimeButton @click="emit('closeDialog')" label="Cancel" variant="secondary" class="p-btn-root_secondary" />
            <PrimeButton @click="handleBlock" label="Block" variant="error" class="p-btn-root_error" :loading="blockLoader" />
        </div>
    </div>
</template>
<script setup lang="ts">
import { useContactsStore } from '~/stores/person/contacts';

const contactStore = useContactsStore();
const emit = defineEmits<{
    (e: 'closeDialog'): void;
}>();
const blockLoader = ref(false);

const handleBlock = () => {
    //remove simulation
    // blockLoader.value = true;

    // setTimeout(() => {
    //     if (contactStore.selectedContact) {
    //         contactStore.selectedContact.blocked = true;
    //     }
    //     contactStore.blockContact();
    //     blockLoader.value = false;
    //     emit('closeDialog');
    // }, 3000);
};
</script>
<style lang="scss" scoped>
.block-ftr-main {
    display: flex;
    padding-top: 32px;
    flex-direction: column;
    align-items: flex-end;
    align-self: stretch;

    .block-ftr-con {
        display: flex;
        padding: 0px 24px 24px 24px;
        justify-content: flex-end;
        align-items: flex-start;
        gap: 12px;
        align-self: stretch;
    }
}
</style>
